import { bool, string } from 'prop-types';

import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material';

import BackgroundImage from '../shared/img/gordon-connect.png';

import { useRetailerSettings } from '../hooks/useRetailerSettings';

const GordonCard = ({ title, content, url, externalLink }) => {
  const { retailerSettings } = useRetailerSettings();

  // Only display if retailer ID matches
  if (retailerSettings?.id !== '3ec5b1d1-9de7-4c89-bba8-b401177407e1') {
    return null;
  }

  const backgroundImage = BackgroundImage;
  
  const cardContent = (
    <Box
      sx={{
        position: 'relative',
        background: 'transparent',
      }}
    >
      {/* LINK Tag */}
      <Box
        sx={{
          position: 'absolute',
          top: -10,
          left: 10,
          backgroundColor: '#ff0081;',
          color: '#fff',
          px: 2,
          py: 0.5,
          borderRadius: 0,
          fontSize: '0.75rem',
          fontWeight: 'bold',
          zIndex: 1,
        }}
      >
        Gordon Food Service
      </Box>

      {/* Horizontal Card */}
      <Card
        sx={{
          position: 'relative',
          backgroundColor: '#fff',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          height: '100%',
        }}
      >        
        <CardContent
          sx={{
            p: 0,
            pb: '0 !important',
          }}
        >
          <Grid container>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  height: '100%',
                  backgroundImage: `url(${backgroundImage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  backgroundSize: "cover",
                  minHeight: "250px",
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                spacing={2}
                direction={'column'}
                justifyContent={'center'}
                sx={{
                  px: 3,
                  height: '100%',
                }}
              >
                <Typography
                  className="text-primary"
                  variant='h4'
                  sx={{
                    lineHeight: 1,
                    fontWeight: 'bold',
                    color: retailerSettings?.brand_color_2,
                    pt: 2,
                  }}
                >
                  {title}
                </Typography>

                <Typography
                  className="text-primary"
                  sx={{
                    color: '#333',
                    pb: 2,
                  }}
                >
                  {content}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );

  return (
    <>
      {externalLink ? (
        <a target='_blank' href={url}>
          {cardContent}
        </a>
      ) : (
        <a href={url}>
          {cardContent}
        </a>
      )}
    </>
  );
};

GordonCard.propTypes = {
  title: string.isRequired,
  content: string.isRequired,
  url: string.isRequired,
  externalLink: bool
};

export default GordonCard;
